import { put, takeLatest } from "redux-saga/effects";
import { SET_DEFAULT_CART_ACTION } from "../../actions/OrderPageAction/actionTypes";

import * as orderPageAction from "../../actions/OrderPageAction";
import * as globalAction from "../../actions/GlobalAction";

function* setDefaultCart(action) {
	yield put(orderPageAction.setDataCalculateCartAction({}));
	yield put(orderPageAction.setDataIdPromotionChoosesAction([]));
	yield put(globalAction.setProductPrevious(undefined));
	if (action.params === "SUCCESS") {
		yield put(orderPageAction.setCartAction([]));
		yield put(orderPageAction.setSelectProductDraftAction([]));
	}
}

function* postCreateOrderSaga() {
	yield takeLatest(SET_DEFAULT_CART_ACTION, setDefaultCart);
}

export default postCreateOrderSaga;
